import {
  SET_USER_SESSION,
  LOGOUT_CLEAR_USER_SESSION,
  SET_VERIFY_USER,
  SET_VERIFY_SHOW,
  SET_EMAIL_OTP_FLAG_VERIFY,
  SET_MOBILE_OTP_FLAG_VERIFY,
  SET_RESET_PWD_SHOW,
  SET_USERNAME,
  SET_API_REPO_VERSION,
} from "../../common/constants/ActionTypes";

const initialState = {
  accessToken: "",
  verify_user: "",
  username: "",
  flg_verify_show: false,
  email_otp_flag: false,
  mobile_otp_flag: false,
  reset_password_show: false,
  authData: null,
  apiRepoVersion: "",
};

export default function loginReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USER_SESSION:
      return {
        ...state,
        accessToken: action.payload,
        authData: action.authData,
      };
    case LOGOUT_CLEAR_USER_SESSION:
      return {
        ...state,
        accessToken: "",
      };
    case SET_VERIFY_USER:
      return {
        ...state,
        verify_user: action.payload,
      };
    case SET_VERIFY_SHOW:
      return {
        ...state,
        flg_verify_show: action.payload,
      };
    case SET_EMAIL_OTP_FLAG_VERIFY:
      return {
        ...state,
        email_otp_flag: action.payload,
      };
    case SET_MOBILE_OTP_FLAG_VERIFY:
      return {
        ...state,
        mobile_otp_flag: action.payload,
      };
    case SET_RESET_PWD_SHOW:
      return {
        ...state,
        reset_password_show: action.payload,
      };
    case SET_USERNAME:
      return {
        ...state,
        username: action.payload,
      };
    case SET_API_REPO_VERSION:
      return {
        ...state,
        apiRepoVersion: action.payload,
      };

    default:
      return state;
  }
}
